import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo/health_gnb.png'


const _withScopeId = n => (_pushScopeId("data-v-e9329854"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "top__wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" Health&u는"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 자가 건강관리를 지원하는"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 헬스케어 플랫폼입니다. ")
], -1))
const _hoisted_4 = { class: "top__wrap__nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "active" }, "헬스케어 플랫폼", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top__bg" }, null, -1))
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "wrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card__title" }, [
  /*#__PURE__*/_createTextVNode(" 헬스앤유 2.0을 기반으로 제공되는"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("더조인만이 할 수 있는 "),
  /*#__PURE__*/_createElementVNode("span", null, "통합 서비스")
], -1))
const _hoisted_11 = {
  class: "card__fade",
  id: "card"
}
const _hoisted_12 = { class: "card__fade__tab" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "card__fade__img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "card-mobile" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "hover-area" }
const _hoisted_19 = { class: "wrap" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", null, "통합 서비스"),
  /*#__PURE__*/_createTextVNode(" 기반의 모듈식 구조로"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("다양한 요구사항에 유연하게 적용됩니다. ")
], -1))
const _hoisted_21 = { class: "hover-area__pc pbr" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "hover-wrap" }
const _hoisted_24 = { class: "center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "center__gnb",
  src: _imports_0,
  alt: "gnb"
}, null, -1))
const _hoisted_26 = { class: "center__bottom" }
const _hoisted_27 = { class: "right" }
const _hoisted_28 = { class: "hover-area__tablet tbr" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-left" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "hover-area__mobile mbr" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-left" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "service" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "service__title" }, [
  /*#__PURE__*/_createTextVNode(" 당신의 고객에게 다양한 기능으로"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("가장 이상적인 헬스케어 서비스를 제공하세요 ")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service__img" }, null, -1))
const _hoisted_43 = { class: "project" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "project__title" }, [
  /*#__PURE__*/_createTextVNode(" 많은 사람들이 사용하고 있는"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("검증된 헬스케어 플랫폼 ")
], -1))
const _hoisted_45 = {
  class: "project__img",
  id: "image"
}
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "project__count" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "project__count__subtitle" }, [
  /*#__PURE__*/_createTextVNode(" 회원들의 건강관리 서비스 제공, 지자체의 핵심 추진사업"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("그리고 실증을 위한 연구과제 등 다양한 프로젝트에 이용되고 있습니다. ")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "count-up" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "count-up__label" }, " 누적 사용자 수 "),
  /*#__PURE__*/_createElementVNode("strong", {
    class: "count-up__num",
    id: "count1"
  }),
  /*#__PURE__*/_createElementVNode("small", null, "명")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "count-up" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "count-up__label" }, " 참여 기관 수 "),
  /*#__PURE__*/_createElementVNode("strong", {
    class: "count-up__num",
    id: "count2"
  }),
  /*#__PURE__*/_createElementVNode("small", null, "기관")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "join-title" }, [
  /*#__PURE__*/_createTextVNode(" 이 모든 서비스를"),
  /*#__PURE__*/_createElementVNode("br", { class: "pbr" }),
  /*#__PURE__*/_createElementVNode("br", { class: "tbr" }),
  /*#__PURE__*/_createTextVNode(" 라이선스 계약 후 "),
  /*#__PURE__*/_createElementVNode("br", { class: "mbr" }),
  /*#__PURE__*/_createElementVNode("span", null, "단 1일 이내"),
  /*#__PURE__*/_createTextVNode("에 제공합니다. ")
], -1))
const _hoisted_52 = { class: "join" }
const _hoisted_53 = { class: "join__wrap" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-mail" }, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-phone" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_CustomBtn = _resolveComponent("CustomBtn")!
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createBlock(_component_Layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
            }, " 홈 "),
            _hoisted_5,
            _hoisted_6
          ])
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardTabArr, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.i,
                  class: _normalizeClass(
								$setup.activeTabIndex != -1 &&
								item.title ==
									$setup.cardTabArr[$setup.activeTabIndex].title
									? 'active'
									: null
							),
                  onClick: ($event: any) => (
								[
									$setup.stopAndStartTimer(),
									($setup.activeTabIndex = index),
								]
							)
                }, _toDisplayString(item.title), 11, _hoisted_13))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardTabArr, (item) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: item.i,
                  class: _normalizeClass(
								$setup.activeTabIndex != -1 &&
								item.img ==
									$setup.cardTabArr[$setup.activeTabIndex].img
									? 'active'
									: null
							),
                  src: item.img,
                  alt: "카드"
                }, null, 10, _hoisted_15))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Swiper, _mergeProps($setup.tabOption, {
            class: "card-mobile__tab",
            controller: { control: $setup.cardSwiper },
            modules: [$setup.Controller, $setup.Autoplay],
            onSwiper: $setup.onTabSwiper
          }), {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardTabArr, (item, index) => {
                return (_openBlock(), _createBlock(_component_SwiperSlide, {
                  class: _normalizeClass(["card-mobile__tab__slide", 
							index == $setup.tabIndex ? 'active' : null
						]),
                  key: item.i,
                  onSlideChange: _cache[1] || (_cache[1] = 
							() => {
								_ctx.$log(
									'active cardSwiper sbsb' +
										$setup.cardSwiper.activeIndex
								);
							}
						),
                  onClick: ($event: any) => (
							[
								$setup.cardSwiper.slideTo(index),
								($setup.tabIndex = index),
							]
						)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"]))
              }), 128))
            ]),
            _: 1
          }, 16, ["controller", "modules", "onSwiper"])
        ]),
        _createVNode(_component_Swiper, _mergeProps($setup.cardOption, {
          class: "card-mobile__card-wrap",
          controller: { control: $setup.tabSwiper },
          modules: [$setup.Controller, $setup.Autoplay],
          onSwiper: $setup.onCardSwiper,
          autoplay: {
					delay: 6000,
					disableOnInteraction: false,
				},
          centeredSlides: true,
          onSlideChange: _cache[2] || (_cache[2] = 
					(val) => {
						$setup.tabIndex = val.activeIndex;
						_ctx.$log(
							'slide.activeIndex val ',
							val.activeIndex
						);
						_ctx.$log('active cardSwiper', $setup.cardSwiper);

						$setup.cardSwiper.activeIndex =
							val.activeIndex;
					}
				)
        }), {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mobileCardArr, (item) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, {
                class: "card-mobile__card-wrap__slide",
                key: item.i
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: item,
                    alt: "img"
                  }, null, 8, _hoisted_17)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 16, ["controller", "modules", "onSwiper"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: "hover-area__pc__btn",
              style: _normalizeStyle(
							'background:' +
							$setup.hoverInfo[$setup.hoverIndex].color
						)
            }, _toDisplayString($setup.hoverInfo[$setup.hoverIndex].btnTxt), 5),
            _createElementVNode("p", {
              innerHTML: 
							$setup.hoverInfo[$setup.hoverIndex].subtitle
						
            }, null, 8, _hoisted_22),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", {
                class: "left hover-zone",
                onMouseover: _cache[3] || (_cache[3] = ($event: any) => ($setup.hoverIndex = 1)),
                onMouseout: _cache[4] || (_cache[4] = ($event: any) => ($setup.hoverIndex = 0))
              }, null, 32),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", {
                  class: "center__top hover-zone",
                  onMouseover: _cache[5] || (_cache[5] = ($event: any) => ($setup.hoverIndex = 2)),
                  onMouseout: _cache[6] || (_cache[6] = ($event: any) => ($setup.hoverIndex = 0))
                }, null, 32),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", {
                    class: "center__bottom__big hover-zone",
                    onMouseover: _cache[7] || (_cache[7] = ($event: any) => ($setup.hoverIndex = 3)),
                    onMouseout: _cache[8] || (_cache[8] = ($event: any) => ($setup.hoverIndex = 0))
                  }, null, 32),
                  _createElementVNode("div", {
                    class: "center__bottom__small hover-zone",
                    onMouseover: _cache[9] || (_cache[9] = ($event: any) => ($setup.hoverIndex = 4)),
                    onMouseout: _cache[10] || (_cache[10] = ($event: any) => ($setup.hoverIndex = 0))
                  }, null, 32),
                  _createElementVNode("div", {
                    class: "center__bottom__small hover-zone",
                    onMouseover: _cache[11] || (_cache[11] = ($event: any) => ($setup.hoverIndex = 5)),
                    onMouseout: _cache[12] || (_cache[12] = ($event: any) => ($setup.hoverIndex = 0))
                  }, null, 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", {
                  class: "right__top hover-zone",
                  onMouseover: _cache[13] || (_cache[13] = ($event: any) => ($setup.hoverIndex = 6)),
                  onMouseout: _cache[14] || (_cache[14] = ($event: any) => ($setup.hoverIndex = 0))
                }, null, 32),
                _createElementVNode("div", {
                  class: "right__bottom hover-zone",
                  onMouseover: _cache[15] || (_cache[15] = ($event: any) => ($setup.hoverIndex = 7)),
                  onMouseout: _cache[16] || (_cache[16] = ($event: any) => ($setup.hoverIndex = 0))
                }, null, 32)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            (
							$setup.configSwiper &&
							!$setup.configSwiper.isBeginning
						)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "slide-btn left",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.configSwiper.slidePrev()))
                }, _hoisted_30))
              : _createCommentVNode("", true),
            (
							$setup.configSwiper && !$setup.configSwiper.isEnd
						)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "slide-btn right",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.configSwiper.slideNext()))
                }, _hoisted_32))
              : _createCommentVNode("", true),
            _createVNode(_component_Swiper, _mergeProps({ onSwiper: $setup.onConfigSwiper }, {
							slidesPerView: 1,
						}, { class: "hover-area__tablet__slide" }), {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.configTabletImg, (item) => {
                  return (_openBlock(), _createBlock(_component_SwiperSlide, {
                    key: item.i
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: item,
                        alt: "image"
                      }, null, 8, _hoisted_33)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 16, ["onSwiper"])
          ]),
          _createElementVNode("div", _hoisted_34, [
            (
							$setup.configSwiper2 &&
							!$setup.configSwiper2.isBeginning
						)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "slide-btn left",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.configSwiper2.slidePrev()))
                }, _hoisted_36))
              : _createCommentVNode("", true),
            (
							$setup.configSwiper2 &&
							!$setup.configSwiper2.isEnd
						)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "slide-btn right",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.configSwiper2.slideNext()))
                }, _hoisted_38))
              : _createCommentVNode("", true),
            _createVNode(_component_Swiper, _mergeProps({ onSwiper: $setup.onConfigSwiper2 }, {
							slidesPerView: 1,
						}, { class: "hover-area__mobile__slide" }), {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.configMobileImg, (item) => {
                  return (_openBlock(), _createBlock(_component_SwiperSlide, {
                    key: item.i
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: item,
                        alt: "image"
                      }, null, 8, _hoisted_39)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 16, ["onSwiper"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _hoisted_42,
        _createVNode(_component_CustomBtn, {
          text: '자세한 기능 보러가기',
          onOnClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$router.push('/health_mobile')))
        })
      ]),
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.projectImg, (img, index) => {
            return (_openBlock(), _createElementBlock("img", {
              key: img.i,
              class: _normalizeClass(
						$setup.activeProjectIndex == index
							? 'active'
							: null
					),
              src: img,
              alt: "모바일 이미지"
            }, null, 10, _hoisted_46))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          _hoisted_49,
          _hoisted_50,
          _createVNode(_component_CustomBtn, {
            text: '더 많은 사례',
            onOnClick: _cache[22] || (_cache[22] = ($event: any) => (
						_ctx.$router.push('/health_business')
					))
          })
        ])
      ]),
      _hoisted_51,
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("button", {
            class: "join__wrap__btn",
            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => ($setup.openEmail && $setup.openEmail(...args)))
          }, [
            _hoisted_54,
            _createTextVNode(_toDisplayString(!$setup.isMobile
							? 'thejoin@thejoin.co.kr'
							: 'E-MAIL'), 1)
          ]),
          _createElementVNode("button", {
            class: "join__wrap__btn",
            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => ($setup.openCall && $setup.openCall(...args)))
          }, [
            _hoisted_55,
            _createTextVNode(_toDisplayString(!$setup.isMobile ? '+82-2-6949-0335' : 'CALL'), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}